var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9937 11C18.9937 12.3199 15.7033 17.0714 10.4937 17.0714C5.28397 17.0714 1.99365 12.3199 1.99365 11",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6527 13.5311C17.2383 14.0268 16.7335 14.5334 16.1464 15.0027L19.4947 16.7327C20.0132 16.2533 20.4979 15.7492 20.947 15.2332L17.6527 13.5311ZM13.7265 16.4334C13.1217 16.6793 12.472 16.8669 11.7814 16.9732L13.2016 20.2437C13.8615 20.0884 14.4983 19.8775 15.1105 19.6205L13.7265 16.4334ZM8.6461 16.8677C7.97071 16.7168 7.33824 16.4892 6.75272 16.2089L5.40549 19.3114C6.0008 19.6025 6.62125 19.8509 7.26556 20.047L8.6461 16.8677ZM4.60721 14.8105C4.03483 14.3256 3.54811 13.8089 3.15546 13.3108L0 14.9412C0.435944 15.4614 0.907767 15.9721 1.41377 16.4605L4.60721 14.8105Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHide);
export default __webpack_public_path__ + "static/media/password-hide.842d4795e755e945534bc6c5887e602a.svg";
export { ForwardRef as ReactComponent };